import { useMemo, useState } from 'react';
import { DisclaimerContext } from './Disclaimercontext';

export const DisclaimerProvider = ({ children }) => {
  const [isDisclaimerVisible, setIsDisclaimerVisible] = useState(false);
  const value = useMemo(() => ({ isDisclaimerVisible, setIsDisclaimerVisible }), [isDisclaimerVisible]);
  return <DisclaimerContext.Provider value={value}>{children}</DisclaimerContext.Provider>;
};
